// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { Link } from 'react-router-dom'
// import ReactPaginate from 'react-paginate'
// import * as XLSX from 'xlsx'
// import DatePicker from 'react-multi-date-picker'
// import moment from 'moment'; 
// import { DateObject } from 'react-multi-date-picker'
// import admindata from '../../components/admindata'
// import { apiRequest } from '../../apiServices/allApi'

// const $ = require('jquery')
// $.Datatable = require('datatables.net')

// const PenaltyReport = () => {
//   const [user, setUser] = useState()
// const id = localStorage.getItem('id')
//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
//   const nodeMode = process.env.NODE_ENV
//   if (nodeMode === 'development') {
//     var baseUrl = beckendLocalApiUrl
//   } else {
//     baseUrl = beckendLiveApiUrl
//   }

//   const searchHandler = (event) => {
//     let key = event.target.value;
//     setSearchList(key);
//   };

//   //user for searching..
//   const [searchList, setSearchList] = useState(0);
//   const [searchType, setSearchType] = useState("Phone");

//   //use for pagination..
//   let [limit, setLimit] = useState(20)

//   const setpageLimit = event => {
//     let key = event.target.value
//     setLimit(key)
//   }
//   const [pageNumber, setPageNumber] = useState(0)
//   const [numberOfPages, setNumberOfPages] = useState(0)
//   const Year = new Date().getFullYear();
//   const Month = new Date().getMonth() + 1; // Adding 1 to the month since getMonth() returns 0-11
  
//   const formattedMonth = Month < 10 ? `0${Month}` : `${Month}`;
  
//   const dynamicStartDate = `${Year}/${formattedMonth}/01`;
//   const dynamicEndDate = `${Year}/${formattedMonth}/31`;
  
//   const [startDate, setStartDate] = useState(dynamicStartDate);
//   const [endDate, setEndDate] = useState(dynamicEndDate);

//   const handleStartDateChange = (date) => {
//     setStartDate(date);
//   };

//   const handleEndDateChange = (date) => {
//     setEndDate(date);
//   };

//   //react paginate..
//   const handlePageClick = async data => {
//     let currentPage = data.selected + 1
//     setPageNumber(currentPage)
//     // scroll to the top
//     //window.scrollTo(0, 0)
//   }

//   // const profle = () => {
//   //   const access_token = localStorage.getItem('token')
//   //   const headers = {
//   //     Authorization: `Bearer ${access_token}`
//   //   }
//   //   axios
//   //     .get(
//   //       baseUrl +
//   //         `admin/get_txn/penaltyreports/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&FROM_DATE=${startDate}&TO_DATE=${endDate}`,
//   //       { headers }
//   //     )
//   //     .then(res => {
//   //       console.log(res.data.admin)
//   //       setUser(res.data.datefind)
//   //       setNumberOfPages(res.data.totalPages)
//   //       //$('table').dataTable();
//   //     })
//   // }
//   const profle = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
 
//     try {
//       const res = await apiRequest( `admin/get_txn/penaltyreports/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&FROM_DATE=${startDate}&TO_DATE=${endDate}`, 'GET',null , headers);
//       // console.log(res.admin)
//       setUser(res.data.datefind)
//       setNumberOfPages(res.data.totalPages)
//     } catch (error) {
//       // console.log(error.message);
//     } finally {
//       // setLoading(false)
//     }
//   };

//   const dateFormat = e => {
//     const date = new Date(e)
//     const newDate = date.toLocaleString('default', {
//       year: 'numeric',
//       month: 'numeric',
//       day: 'numeric'
//     })
//     return newDate
//   }

//   useEffect(() => {
//     profle()
//   }, [pageNumber, limit, startDate, endDate, searchList, searchType])

//   if (user === undefined) {
//     return null
//   }

//   const createDownloadData = () => {
//     handleExport()
//   }
//   const handleExport = () => {
//     let table1 = [
//       {
//         A: 'Id',
//         B: 'UserName',
//         C: 'PhoneNumber',
//         D: 'Penalty Amount',
//         E: 'Penalty By'
//         // F:"Penalty by (ID)"
//       }
//     ]

//     user.forEach(row => {
//       const userDetails = row
//       console.log('exldata', userDetails)
//       table1.push({
//         A: userDetails._id,
//         B: userDetails.User_id ? userDetails.User_id.Name : '',
//         C: userDetails.User_id ? userDetails.User_id.Phone : '',
//         D: userDetails.amount,
//         E: userDetails.action_by ? userDetails.action_by.Name : 'N/A'
//         // F:(userDetails.action_by)?userDetails.action_by:'N/A'
//       })
//     })

//     //table1 = [{A:"User Details"}].concat(table1);
//     //const finalData = [...table1];
//     //console.log(finalData);
//     /* convert state to workbook */
//     const ws = XLSX.utils.json_to_sheet(table1, {
//       skipHeader: true
//     })
//     const wb = XLSX.utils.book_new()
//     XLSX.utils.book_append_sheet(wb, ws, 'SheetJS')
//     /* generate XLSX file and send to client */
//     XLSX.writeFile(wb, 'PenaltyReports.xlsx')
//   }
//   return (
//     <>
//       {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
//       <div className='row mt-5'>
//         <div className='col-12 grid-margin'>
//           <div className='card'>
//             <div className='card-body  table_bg'>
//               <h4 className='dashboard_heading'>Penalty Reports</h4>
//               <div className="row mb-4">
//                 <div className="col-md-2 col-sm-12">
//                   <select
//                     className="form-control  "
//                     id="pagelimit"
//                     name="pagelimit"
//                     onChange={setpageLimit}
//                   >
//                     <option value="10">Set limit</option>
//                     <option value="20">20</option>
//                     <option value="50">50</option>
//                     <option value="100">100</option>
//                     <option value="500">500</option>
//                   </select>
//                 </div>
//                 <div className="col-md-2 col-sm-12">
//                   <select
//                     className="form-control "
//                     id="searchType"
//                     name="searchtype"
//                     onChange={(e) => setSearchType(e.target.value)}
//                   >
//                     <option value="0">Select Search by</option>
//                     {/* <option value="Name">Name</option> */}
//                     <option value="Phone">Phone</option>
//                     <option value="_id">User Id</option>
//                     {/* <option value="refferal_code">Refferal Id</option> */}
//                   </select>
//                 </div>
//                 <div className="col-md-2 col-sm-12">
//                   <input
//                     type="text"
//                     placeholder="Search..."
//                     className="form-control "
//                     onChange={searchHandler}
//                   />
//                 </div>
//                 <div className="col-md-4 col-sm-12 ">
//                   <div className="d-flex">

                
//                   <DatePicker
//                     selected={startDate}
//                     value={startDate}
//                     onChange={handleStartDateChange}
//                     selectsStart
//                     startDate={startDate}
//                     endDate={endDate}
//                     placeholderText="Start Date"
//                     style={{ height: "36px" }}
//                   /> 
//                   <h4  className="text-dark m-2"> To</h4>
//                   <DatePicker
//                     selected={endDate}
//                     onChange={handleEndDateChange}
//                     value={endDate}
//                     selectsEnd
//                     startDate={startDate}
//                     endDate={endDate}
//                     placeholderText="End Date"
//                     minDate={startDate} // Ensure that the end date cannot be before the start date
//                     style={{ height: "36px" }}
//                   />
//                   </div>
//                 </div>
               
//                 <div className="col-md-2 col-sm-12">
//                   <button
//                     onClick={() => {
//                       createDownloadData();
//                     }}
//                     className="btn btn-primary sm-ml-0 ml-4 "
//                     style={{ height: "40px" }}
//                   >
//                     Export Data
//                   </button>
//                 </div>
//               </div>
//               <div className='table-responsive'>
//                 <table className='table text-light'>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                           {
//                           id =="6931311e30989ed52eebce14" ?
//                       <th> ID</th> : ""}
//                       <th> Phone</th>
//                       <th> User</th>
//                       <th> Amount </th>
//                       <th> Reason </th>
//                       <th> Status </th>
//                       <th> Date </th>
//                       <th>Penalty by</th>
//                       {/* <th>Penalty by Id</th> */}
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {user &&
//                       user.map((data, key) => (
//                         <tr>
//                           <td>{key + 1}</td>
//                                 {
//                           id =="6931311e30989ed52eebce14" ?
//                           <td>{data._id}</td> : ""}
//                           <td>
//                             {admindata?.user?.usertype == 'Admin' ||
//                             admindata?.user?.updateLegalData === true ? (
//                               <span className='pl-2'>
//                                 {data.User_id ? data.User_id.Phone : ''}
//                               </span>
//                             ) : (
//                               <span className='pl-2'>{`${
//                                 '********' +
//                                 data.User_id.Phone.toString().slice(-2)
//                               }`}</span>
//                             )}
//                           </td>
//                           <td>
//                             {data.User_id && (
//                               <Link
//                                 className='btn btn-sm btn-outline-info'
//                                 to={`/user/view_user/${data.User_id._id}`}
//                               >
//                                 {data.User_id.Name}
//                               </Link>
//                             )}
//                           </td>

//                           <td>{data.amount}</td>
//                           <td>{data.txn_msg}</td>
//                           <td className='font-weight-bold text-success'>
//                             {data.status}
//                           </td>
//                           <td>{dateFormat(data.createdAt).split(',')[0]} </td>
//                           <td>
//                             {data.action_by ? data.action_by.Name : 'N/A'}
//                           </td>
//                           {/* <td>{(data.action_by)?data.action_by:'N/A'}</td> */}
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div className='mt-4'>
//                 <ReactPaginate
//                   previousLabel={'Previous'}
//                   nextLabel={'Next'}
//                   breakLabel={'...'}
//                   pageCount={numberOfPages}
//                   marginPagesDisplayed={2}
//                   pageRangeDisplayed={3}
//                   onPageChange={handlePageClick}
//                   containerClassName={'pagination justify-content-center'}
//                   pageClassName={'page-item'}
//                   pageLinkClassName={'page-link'}
//                   previousClassName={'page-item'}
//                   previousLinkClassName={'page-link'}
//                   nextClassName={'page-item'}
//                   nextLinkClassName={'page-link'}
//                   breakClassName={'page-item'}
//                   breakLinkClassName={'page-link'}
//                   activeClassName={'active'}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default PenaltyReport



import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import * as XLSX from 'xlsx'
import DatePicker from 'react-multi-date-picker'
import moment from 'moment'; 
import { DateObject } from 'react-multi-date-picker'
import admindata from '../../components/admindata'
import { apiRequest } from '../../apiServices/allApi'

const $ = require('jquery')
$.Datatable = require('datatables.net')

const PenaltyReport = () => {
  const [user, setUser] = useState()
  const id = localStorage.getItem('id')
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }

  const searchHandler = (event) => {
    let key = event.target.value;
    setSearchList(key);
  };

  // User for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState("Phone");

  // Use for pagination..
  let [limit, setLimit] = useState(20)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
  const Year = new Date().getFullYear();
  const Month = new Date().getMonth() + 1;
  
  const formattedMonth = Month < 10 ? `0${Month}` : `${Month}`;
  
  const dynamicStartDate = `${Year}/${formattedMonth}/01`;
  const dynamicEndDate = `${Year}/${formattedMonth}/31`;
  
  const [startDate, setStartDate] = useState(dynamicStartDate);
  const [endDate, setEndDate] = useState(dynamicEndDate);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  // React paginate..
  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
  }

  const profle = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
 
    try {
      const res = await apiRequest(`admin/get_txn/penaltyreports/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&FROM_DATE=${startDate}&TO_DATE=${endDate}`, 'GET', null, headers);
      setUser(res.data.datefind)
      setNumberOfPages(res.data.totalPages)
    } catch (error) {
      console.log(error.message);
    }
  };

  const dateFormat = e => {
    if (!e) return "N/A"
    const date = new Date(e)
    const newDate = date.toLocaleString('default', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    })
    return newDate
  }

  useEffect(() => {
    profle()
  }, [pageNumber, limit, startDate, endDate, searchList, searchType])

  // Helper function to return inline styles for the Status badge
  const getStatusBadgeStyle = (status) => {
    const baseStyle = {
      display: "inline-block",
      padding: "4px 12px",
      borderRadius: "20px",
      fontSize: "12px",
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    };

    switch (status?.toLowerCase()) {
      case "success":
      case "completed":
        return {
          ...baseStyle,
          backgroundColor: "#16a34a",
          color: "#ffffff",
        };
      case "pending":
        return {
          ...baseStyle,
          backgroundColor: "#ca8a04",
          color: "#ffffff",
        };
      case "failed":
      case "cancelled":
        return {
          ...baseStyle,
          backgroundColor: "#dc2626",
          color: "#ffffff",
        };
      case "new":
        return {
          ...baseStyle,
          backgroundColor: "#2563eb",
          color: "#ffffff",
        };
      default:
        return {
          ...baseStyle,
          backgroundColor: "#6b7280",
          color: "#ffffff",
        };
    }
  };

  if (user === undefined) {
    return null
  }

  const createDownloadData = () => {
    handleExport()
  }

  const handleExport = () => {
    let table1 = [
      {
        A: 'Id',
        B: 'UserName',
        C: 'PhoneNumber',
        D: 'Penalty Amount',
        E: 'Penalty By'
      }
    ]

    user.forEach(row => {
      const userDetails = row
      table1.push({
        A: userDetails._id,
        B: userDetails.User_id ? userDetails.User_id.Name : '',
        C: userDetails.User_id ? userDetails.User_id.Phone : '',
        D: userDetails.amount,
        E: userDetails.action_by ? userDetails.action_by.Name : 'N/A'
      })
    })

    const ws = XLSX.utils.json_to_sheet(table1, {
      skipHeader: true
    })
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'SheetJS')
    XLSX.writeFile(wb, 'PenaltyReports.xlsx')
  }

  return (
    <div className="conflictgame-container">
      <div className="conflictgame-main-card">
        <h2 className="conflictgame-heading">Penalty Reports</h2>

        {/* Filter Controls Row */}
        <div className="row mb-4 align-items-center">
          <div className="col-md-2 col-sm-6 mb-2">
            <select
              className="form-control"
              id="pagelimit"
              name="pagelimit"
              onChange={setpageLimit}
              style={{ height: "40px", borderRadius: "8px" }}
            >
              <option value="20">Limit: 20</option>
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
          </div>

          <div className="col-md-2 col-sm-6 mb-2">
            <select
              className="form-control"
              id="searchType"
              name="searchtype"
              onChange={(e) => setSearchType(e.target.value)}
              style={{ height: "40px", borderRadius: "8px" }}
            >
              <option value="Phone">Search by Phone</option>
              <option value="_id">Search by User ID</option>
            </select>
          </div>

          <div className="col-md-2 col-sm-6 mb-2">
            <input
              type="text"
              placeholder="Search..."
              className="form-control"
              onChange={searchHandler}
              style={{ height: "40px", borderRadius: "8px" }}
            />
          </div>

          <div className="col-md-4 col-sm-12 mb-2">
            <div className="d-flex align-items-center">
              <DatePicker
                selected={startDate}
                value={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Start Date"
                style={{ height: "40px", borderRadius: "8px", width: "100%" }}
              />
              <span className="mx-2 text-light font-weight-bold">To</span>
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                value={endDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                placeholderText="End Date"
                minDate={startDate}
                style={{ height: "40px", borderRadius: "8px", width: "100%" }}
              />
            </div>
          </div>

          <div className="col-md-2 col-sm-6 mb-2 text-right">
            <button
              onClick={createDownloadData}
              className="btn btn-primary w-100 font-weight-bold"
              style={{ height: "40px", borderRadius: "8px" }}
            >
              Export Excel
            </button>
          </div>
        </div>

        {/* Responsive Modern Table */}
        <div className="table-responsive-wrapper">
          <table className="conflictgame-modern-table">
            <thead>
              <tr>
                <th>#</th>
                {id === "6931311e30989ed52eebce14" && <th>Transaction ID</th>}
                <th>Phone</th>
                <th>User</th>
                <th>Amount</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Date</th>
                <th>Penalty By</th>
              </tr>
            </thead>

            <tbody>
              {user && user.length > 0 ? (
                user.map((data, key) => (
                  <tr key={data._id || key}>
                    <td>{pageNumber > 1 ? (pageNumber - 1) * limit + key + 1 : key + 1}</td>

                    {id === "6931311e30989ed52eebce14" && (
                      <td style={{ fontFamily: "monospace", color: "#a5b4fc" }}>
                        {data._id}
                      </td>
                    )}

                    <td>
                      {admindata?.user?.usertype === 'Admin' ||
                      admindata?.user?.updateLegalData === true ? (
                        <span>
                          {data.User_id ? data.User_id.Phone : 'N/A'}
                        </span>
                      ) : (
                        <span>
                          {data.User_id?.Phone
                            ? `********${data.User_id.Phone.toString().slice(-2)}`
                            : 'N/A'}
                        </span>
                      )}
                    </td>

                    <td>
                      {data.User_id ? (
                        <Link
                          className="btn-conflictgame-view"
                          to={`/user/view_user/${data.User_id._id}`}
                        >
                          {data.User_id.Name || "View User"}
                        </Link>
                      ) : (
                        "N/A"
                      )}
                    </td>

                    <td>
                      <span className="game-amount-text">₹{data.amount}</span>
                    </td>

                    <td style={{ color: "#cbd5e1" }}>{data.txn_msg || "N/A"}</td>

                    <td>
                      <span style={getStatusBadgeStyle(data.status)}>
                        {data.status || "N/A"}
                      </span>
                    </td>

                    <td>{dateFormat(data.createdAt).split(',')[0]}</td>

                    <td>
                      <span className="player-name-text">
                        {data.action_by ? data.action_by.Name : 'N/A'}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={id === "6931311e30989ed52eebce14" ? "9" : "8"}
                    style={{ textAlign: "center", padding: "24px", color: "#94a3b8" }}
                  >
                    No Penalty Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {numberOfPages > 1 && (
          <div className="pagination-container" style={{ marginTop: "20px" }}>
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageCount={numberOfPages}
              forcePage={pageNumber > 0 ? pageNumber - 1 : 0}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={'pagination justify-content-center'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default PenaltyReport